module.exports = __webpack_public_path__ + "static/media/newsletter-august-2021-building-program.0658e366.jpg";